import * as Base from "@base-ui/react"
import { createElement, type PropsWithChildren } from "react"

export function Menu(props: PropsWithChildren<Base.Menu.Root.Props>) {
  const { children, ...rest } = props
  return <Base.Menu.Root {...rest}>{children}</Base.Menu.Root>
}

export namespace Menu {
  export function Button(props: PropsWithChildren<Base.Menu.Trigger.Props>) {
    const { children, ...rest } = props
    return <Base.Menu.Trigger {...rest}>{children}</Base.Menu.Trigger>
  }

  export function Group(props: PropsWithChildren<Base.Menu.Group.Props>) {
    const { children, ...rest } = props
    return <Base.Menu.Group {...rest}>{children}</Base.Menu.Group>
  }

  export function GroupLabel(
    props: PropsWithChildren<Base.Menu.GroupLabel.Props>,
  ) {
    const { children, ...rest } = props
    return (
      <Base.Menu.GroupLabel
        className="mb-1 font-semibold text-[12px] text-muted"
        {...rest}
      >
        {children}
      </Base.Menu.GroupLabel>
    )
  }
  export function Item(
    props: PropsWithChildren<
      Base.Menu.Item.Props & { active?: boolean; icon?: React.ExoticComponent }
    >,
  ) {
    const { active, children, icon, ...rest } = props
    return (
      <Base.Menu.Item
        {...(active && {
          "data-active": true,
        })}
        className="relative -mx-2 flex h-8 w-[calc(100% cursor-default items-center rounded-md px-2 font-medium text-sm hover:bg-control-transparent-hover active:bg-control-transparent-active data-active:bg-control-transparent-selected data-active:font-bold"
        {...rest}
      >
        {icon && <div className="mr-2 text-muted">{createElement(icon)}</div>}
        {children}
      </Base.Menu.Item>
    )
  }

  export function Menu(props: PropsWithChildren<Base.Menu.Popup.Props>) {
    const { children, ...rest } = props
    return (
      <Base.Menu.Portal>
        <Base.Menu.Positioner sideOffset={4}>
          <Base.Menu.Popup
            className="z-50 w-50 rounded-xl border border-neutral-6 bg-muted p-3 [&>[role='group']+[role='group']]:mt-2"
            {...rest}
          >
            {children}
          </Base.Menu.Popup>
        </Base.Menu.Positioner>
      </Base.Menu.Portal>
    )
  }

  export function Separator(
    props: PropsWithChildren<Base.Menu.Separator.Props>,
  ) {
    const { children, ...rest } = props
    return (
      <Base.Menu.Separator
        className="mt-2 mb-3 h-px w-full bg-neutral-6"
        {...rest}
      >
        {children}
      </Base.Menu.Separator>
    )
  }
}
